import { Component, output } from '@angular/core';
import {
  MatDatepickerModule,
  MatDateRangePicker,
} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  imports: [MatDatepickerModule, MatFormFieldModule, MatIconModule],

  selector: 'norupe-month-picker',
  styles: ``,
  templateUrl: './month-picker.component.html',
})
export class MonthPickerComponent {
  startDate = output<Date | null>();
  endDate = output<Date | null>();
  //VALUES JUST FOR MONT SELECTION SINCE THEY DONT SHOW UP WHEN SELECTING FROM A year view
  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;

  onMonthSelected(date: Date, monthPicker: MatDateRangePicker<Date>) {
    // fires off event when selects MONTH FROM MONTH VIEW
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.setUiAndEmitDates(start, end);
    monthPicker.close();
  }

  setUiAndEmitDates(start: Date | null, end: Date | null) {
    this.selectedStartDate = start;
    this.selectedEndDate = end;
    this.startDate.emit(start);
    this.endDate.emit(end);
  }
  clearDate() {
    this.setUiAndEmitDates(null, null);
  }
}
